import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children, requireProfile = false }) {
  const location = useLocation();
  const { user, loading, profileLoading, profileComplete } = useAuth();

  if (loading || (user && profileLoading)) {
    return <div className="p4r-route-guard"><div className="spinner-border" role="status" /><p>Checking your account…</p></div>;
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname, reason: 'signin' }} />;
  if (requireProfile && !profileComplete) return <Navigate to="/settings" replace state={{ from: location.pathname, reason: 'profile' }} />;
  return children;
}
